// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.2_@swc+helpers@0.5.23__webpack@5.110.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.2_@swc+helpers@0.5.23__webpack@5.110.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calenderview-container {
  position: absolute;
  top: -275px;
  right: -1px;
  z-index: 10;
  width: 260px;
  min-height: 260px;
}
`, "",{"version":3,"sources":["webpack://./app/components/Shared/DatePicker/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":[".calenderview-container {\n  position: absolute;\n  top: -275px;\n  right: -1px;\n  z-index: 10;\n  width: 260px;\n  min-height: 260px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
